import * as React from 'react';
// An alignment context that acts as a no-op.
export const inertAlignContextProps = {
  size: 0,
  lineHeight: 0,
  origin: 'top',
  splitPixels: false
};
const AlignContext = /*#__PURE__*/React.createContext(inertAlignContextProps);
export default AlignContext;